import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'direction-horizontal', 'DirectionHorizontal', [["path",{"d":"M10 9l-3 3l3 3"}],["path",{"d":"M14 9l3 3l-3 3"}]]);